import { InAppState } from "../base/InAppState";
import template from './HelpTemplate.html';

export class HelpState extends InAppState
{
    static ROUTE = '/help';
    static ID = 'help';

    async enter()
    {
        this.app.view.render(
            this.app.view.pageContent,
            template,
            {}
        );

        this._bindEventListeners();
    }

    _bindEventListeners()
    {
        // Accordion toggles — Bootstrap JS doesn't auto-init on dynamically injected HTML
        this.app.view.pageContent.querySelectorAll( '[data-type="accordion-toggle"]' ).forEach( ( btn ) =>
        {
            this.addEventListener( btn, 'click', () =>
            {
                const targetSelector = btn.getAttribute( 'data-target' );
                const target = this.app.view.pageContent.querySelector( targetSelector );

                if ( !target ) return;

                const isOpen = target.classList.contains( 'show' );

                if ( isOpen )
                {
                    target.classList.remove( 'show' );
                    btn.classList.add( 'collapsed' );
                    btn.setAttribute( 'aria-expanded', 'false' );
                }
                else
                {
                    target.classList.add( 'show' );
                    btn.classList.remove( 'collapsed' );
                    btn.setAttribute( 'aria-expanded', 'true' );
                }
            });
        });

        // TOC smooth-scroll links
        this.app.view.pageContent.querySelectorAll( '[data-type="toc-link"]' ).forEach( ( link ) =>
        {
            this.addEventListener( link, 'click', ( e ) =>
            {
                e.preventDefault();
                const targetId = link.getAttribute( 'href' ).substring( 1 );
                const targetEl = document.getElementById( targetId );

                if ( targetEl )
                {
                    targetEl.scrollIntoView( { behavior: 'smooth', block: 'start' } );
                }
            });
        });
    }

    async exit()
    {
    }

    getContentHeaderData()
    {
        return {
            title: 'Help & Documentation',
            breadcrumb: [ 'Help' ]
        };
    }
}
